import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  deserialize,
  getAccountModalLayer,
  getIframe,
  getMethodRegiModalLayer,
  serialize,
  setAccountClass,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  setNumericOnly,
  stringToHTML,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { amtFormatter, isEmpty, removeComma } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const ChargDeposit = {
  render: async () => {
    return `
        <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
        <div class="c_title1">충전머니 충전</div>
        <div class="form-group m_b_20">
            <div class="c_box">
                <label class="c_label1">연결계좌</label>
            </div>
            <div class="c_bod1 c_box skin1_bod" id="account_select">
                <input id="con_acc_entyno" type="hidden" />
                <div id="con_account" class="c_label4_3"></div>
                <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
            </div>
        </div>
        <div class="form-group m_b_20">
            <label class="c_label1">충전금액</label>
            <input id="chrg_amt" type="text" class="form-control c_input1 skin1_input" pattern="[0-9]*" inputmode="numeric">
        </div>
        <div class="form-group m_b_20">
            <label class="c_label1">충전 후 잔액</label>
            <div id="chrg_bal" type="text" class="form-control c_input1 skin1_input"></div>
            <div class="m_t_10">
                <span class="c_label5_1"></span>
            </div>
        </div>
        <div class="bottom_btn_wrapper">
            <button id="charg_deposit_confirm" class="btn c_btn1 skin1_btn" data-toggle="modal" data-target="#charg_confirm">확인</button>
        </div>
    `;
  },
  afterRender: async () => {
    // Set Alert
    setAlertModal();

    let moneyBalance = 0;
    setNumericOnly('chrg_amt');
    try {
      // 충전머니 잔액조회
      const meneyBalanceResult = await getApv('charging/moneyBalance');
      moneyBalance = meneyBalanceResult.chrgBal || 0;

      const accountModalLayer = await getAccountModalLayer();
      stringToHTML(accountModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
    } catch (e) {
      showAlertModal('오류', e.resultMessage);
      console.error(e);
    } finally {
      //잔액 세팅
      setIframeInnerHtml('chrg_bal', amtFormatter(moneyBalance));
    }

    const methodRegiModalLayer = await getMethodRegiModalLayer();
    stringToHTML(methodRegiModalLayer).children[0].appendAfter(
      getIframe().getElementById('layer-wrapper')
    );

    // 충전 금액 변경
    const handleAmtChanged = () => {
      let chrgAmt = removeComma(
        getIframe().getElementById('chrg_amt').value.trim()
      );
      const chrgBal = moneyBalance;

      const regString = /^[0-9]+$/;
      if (!regString.test(chrgAmt)) chrgAmt = '0';

      const newBalance = amtFormatter(Number(chrgBal) + Number(chrgAmt));

      getIframe().getElementById('chrg_amt').value = amtFormatter(chrgAmt);
      setIframeInnerHtml('chrg_bal', newBalance);
    };

    // 연결 계좌 변경
    const handleAccountChanged = (accountInfoStr) => {
      if (isEmpty(accountInfoStr)) return;
      const oldEntyno = getIframe().getElementById('con_acc_entyno').value;

      const accountInfo = deserialize(accountInfoStr);
      const accountNm = `${accountInfo.bnkName} ${accountInfo.accno}`;

      getIframe().getElementById('con_acc_entyno').value =
        accountInfo.accEntyno;
      setIframeInnerHtml('con_account', accountNm);

      const newEntyno = accountInfo.accEntyno;

      setAccountClass(oldEntyno, newEntyno);

      closeBottomSheet('account_select');
    };

    // 주계좌 디폴트 세팅
    const mainAccountStr = localStorage.getItem('CONPAY_MAIN_ACCOUNT');
    handleAccountChanged(mainAccountStr);

    // 충전
    const handleOk = async () => {
      const accEntyno = getIframe().getElementById('con_acc_entyno').value;
      const chrgAmt = removeComma(
        getIframe().getElementById('chrg_amt').value.trim()
      );

      if (isEmpty(chrgAmt) || chrgAmt == '0') {
        showAlertModal('확인', '충전금액을 입력해주세요.', () => {});
      } else {
        // 완료페이지에서 사용할 데이터
        const data = {
          accEntyno,
          chrgAmt,
        };

        const res = await postApv('account/rsvd/charge', data);

        sessionStorage.setItem(
          'CONPAY_COMPLETE_INFO',
          serialize({ ...data, ...res })
        );

        // pin 확인 -> 완료페이지
        pushRouter(
          {
            mode: 'PIN_CHECK',
            nextHash: routes.chargDepositComplete.hashPath,
          },
          null,
          routes.enterPwd.hashPath,
          () => {
            setDisableBackControl();
          }
        );
      }
    };

    // Set event
    getIframe()
      .querySelectorAll('#deposit_account_list > div')
      .forEach((element) =>
        element.addEventListener('click', () => {
          if (element.getAttribute('id') == 'account_regi') {
            pushRouter(null, null, routes.accountRegi.hashPath);
            return;
          }
          handleAccountChanged(element.getAttribute('value'));
        })
      );
    getIframe()
      .getElementById('chrg_amt')
      .addEventListener('change', handleAmtChanged);
    setAddEventListener('charg_deposit_confirm', handleOk);
    setAddEventListener('connect_pay_back_button', () => history.back());
    setBottomSheet('account_select');
  },
};
export default ChargDeposit;
